import React, {  useState,useEffect } from "react";
import "./RetunoThree.css";

function RetinoThree({leftSelection,rightSelection,handleNext,handlePrev}) { 
//state

const [leftChecked1, setleftChecked1] = useState(false);
const [leftChecked2, setleftChecked2] = useState(false);
const [leftChecked3, setleftChecked3] = useState(false);
const [leftChecked4, setleftChecked4] = useState(false);

const [rightChecked1, setrightChecked1] = useState(false);
const [rightChecked2, setrightChecked2] = useState(false);
const [rightChecked3, setrightChecked3] = useState(false);
const [rightChecked4, setrightChecked4] = useState(false);

const [leftPick, setLeftPick] = useState(leftSelection);
const [rightPick, setRightPick] = useState(rightSelection);

useEffect(() => {
  if("R2" in leftPick ){
    if(0 in leftPick.R2){
    setleftChecked1(true)
    }
    if(1 in leftPick.R2){
      setleftChecked2(true)
    }
    if(2 in leftPick.R2){
      setleftChecked3(true)
     }
     if(3 in leftPick.R2){
      setleftChecked4(true)
     }

  }
  if("R2" in rightPick ){
    if(0 in rightPick.R2){
      setrightChecked1(true)
      }
      if(1 in rightPick.R2){
        setrightChecked2(true)
      }
      if(2 in rightPick.R2){
        setrightChecked3(true)
       }
       if(3 in rightPick.R2){
        setrightChecked4(true)
       }
  } 
});

const HandleNextin =()=>{
  var data ={
    Rleft: leftPick,
    Rright: rightPick
  }
 handleNext(data)
 if((rightChecked1 || rightChecked2 || 
  rightChecked3|| rightChecked4)){
  localStorage.setItem("RRight3",
  "Pre-proliferative retinopathy present")
 }else{
  localStorage.setItem("RRight3",
  "")
 }
 if((leftChecked1 || leftChecked2
  || leftChecked3|| leftChecked4)){
  localStorage.setItem("RLeft3",
   "Pre-proliferative retinopathy present")
 }else{
  localStorage.setItem("RLeft3",
  "")
 }

}
const HandlePrevIn =()=>{
  var data ={
    Rleft: leftPick,
    Rright: rightPick
  }
  handlePrev(data)
  if((rightChecked1 || rightChecked2 || 
    rightChecked3|| rightChecked4)){
    localStorage.setItem("RRight3",
    "Pre-proliferative retinopathy present")
   }else{
    localStorage.setItem("RRight3",
    "")
   }
   if((leftChecked1 || leftChecked2
    || leftChecked3||leftChecked4)){
    localStorage.setItem("RLeft3",
     "Pre-proliferative retinopathy present")
   }else{
    localStorage.setItem("RLeft3",
    "")
   }
}
const deleteKey =(obj,keym)=>{
  delete obj[keym]
  return obj
}
const handleChange=(which, pick, position)=>{
  if(which==="right"){  
    if(("R2" in rightPick) || Object.keys(rightPick).length===0){
      //add or remove it
      if("R2" in rightPick){
        var obk =  {...rightPick.R2}
       
        if(rightPick.R2[position] !== undefined){
          var obj = deleteKey(obk, position)
         if(position===0){
          setRightPick({R2: obj })
          setrightChecked1(false)
         }
         if(position===1){
          setRightPick({R2: obj })
          setrightChecked2(false)
         }
         if(position===2){
          setRightPick({R2: obj })
          setrightChecked3(false)
         }
         if(position===3){
          setRightPick({R2: obj })
          setrightChecked4(false)
         }
         if(Object.keys(obj).length===0){
          setRightPick({})
         }
          }else{
            if(position===0){

              setRightPick({R2:{...rightPick.R2, 0:pick}}) 
              setrightChecked1(true)
             }
             if(position===1){
              setRightPick({R2:{...rightPick.R2, 1:pick}})
              setrightChecked2(true)
             }
             if(position===2){
              setRightPick({R2: {...rightPick.R2, 2:pick}})
              setrightChecked3(true)
             }
             if(position===3){
              setRightPick({R2: {...rightPick.R2, 3:pick}})
              setrightChecked4(true)
             }
          }
        // setrightPick({})
        // setrightChecked1(false)
      }
     if(Object.keys(rightPick).length===0){
      if(position===0){
        setRightPick({R2:{0:pick}});
        setrightChecked1(true)
       }
       if(position===1){
        setRightPick({R2:{1:pick}});
        setrightChecked2(true)
       }
       if(position===2){
        setRightPick({R2:{2:pick}});
        setrightChecked3(true)
       }
       if(position===3){
        setRightPick({R2:{3:pick}});
        setrightChecked4(true)
       }
     }
    }
     if(!("R2" in rightPick )&& Object.keys(rightPick).length>0){
      alert("You already selected Retinopathy Grade")
    } 

  }
  if(which==="left"){
    
    if(("R2" in leftPick) || Object.keys(leftPick).length===0){
      //add or remove it
      if("R2" in leftPick){
        var obk =  {...leftPick.R2}
        if(leftPick.R2[position] !== undefined){
          var obj = deleteKey(obk, position)
         if(position===0){
          setLeftPick({R2: obj })
          setleftChecked1(false)
         }
         if(position===1){
          setLeftPick({R2: obj })
          setleftChecked2(false)
         }
         if(position===2){
          setLeftPick({R2: obj })
          setleftChecked3(false)
         }
         if(position===3){
          setLeftPick({R2: obj })
          setleftChecked4(false)
         }
         if(Object.keys(obj).length===0){
          setLeftPick({})
         }
          }else{
            if(position===0){
              setLeftPick({R2:{...leftPick.R2, 0:pick}}) 
              setleftChecked1(true)
             }
             if(position===1){
              setLeftPick({R2:{...leftPick.R2, 1:pick}})
              setleftChecked2(true)
             }
             if(position===2){
              setLeftPick({R2: {...leftPick.R2, 2:pick}})
              setleftChecked3(true)
             }
             if(position===3){
              setLeftPick({R2: {...leftPick.R2, 3:pick}})
              setleftChecked4(true)
             }
          }
        // setLeftPick({})
        // setleftChecked1(false)
      }
     if(Object.keys(leftPick).length===0){
      if(position===0){
        setLeftPick({R2:{0:pick}});
        setleftChecked1(true)
       }
       if(position===1){
        setLeftPick({R2:{1:pick}});
        setleftChecked2(true)
       }
       if(position===2){
        setLeftPick({R2:{2:pick}});
        setleftChecked3(true)
       }
       if(position===3){
        setLeftPick({R2:{3:pick}});
        setleftChecked4(true)
       }
     }
    }
     if(!("R2" in leftPick )&& Object.keys(leftPick).length>0){
      alert("You already selected Retinopathy Grade")
    } 
  }

}

    return (  
        <> 
  
      <div className="nav navbar-expand-lg sticky-top shadow text-center" style={{marginBottom: "10px", backgroundColor: "#000"}}>  
        <div className="container">
            <p className="display-6 text-light text-center">
          R2:One or more present
          </p>
          </div>
        </div>
        <div className="container">
          <div className="container">
            <div className="row">
            <div className="Image shadow col-xl-4 col-md-6">
          <img  className="HeaderSide img-fluid" style={{ height: "auto"}} src={require('../../assests/Images/ret3.jpg')} alt="retina" />
          <div className="Caption text-dark">
            <h5>Source: IDRiD Dataset</h5>
          </div>
          </div>
          <div className="SideTable col-xl-8 col-md-6">
            <div className="container">
            <table className="shadow"  style={{borderRadius: "10px", margin: "5px"}}>
              <tr style={{backgroundColor: "#000"}}>
                <th>
                Criteria
                </th>
                <th>Right Eye
               (tick if present)</th>
               <th>Left Eye
               (tick if present)</th>
              </tr>
              <tr>
                <td className="text-dark">Multiple Blot haemorrhages (~8 or more)</td>
                <td><form>
                <input type="checkbox" 
                 checked={rightChecked1}
                className="CheckBox"
                 id="myCheckRight" 
                 value="haemorrhages"
                onChange={(e) => {handleChange("right", e.target.value, 0)}
                  }/>
                    </form></td>
                <td><form>
                <input type="checkbox" 
                checked={leftChecked1} 
                className="CheckBox"
                value="haemorrhages" 
                id="myCheckleft" 
                onChange={(e) => {handleChange("left",e.target.value, 0)}}/>
               
                  </form></td>
              </tr>
              <tr style={{backgroundColor: "#e9e9e9"}}>
                <td className="text-dark">IRMA</td>
                <td><form>
                <input type="checkbox" 
                 checked={rightChecked2} 
                className="CheckBox" id="myCheckRight" 
                value="IRMA"
                onChange={(e) => {handleChange("right",e.target.value,1)}
                  }/>
                    </form></td>
                <td><form>
                <input type="checkbox" 
                checked={leftChecked2} 
                className="CheckBox" 
                id="myCheckleft" 
                value="IRMA"
                onChange={(e) => {handleChange("left",e.target.value,1)}}/>
               
                  </form></td>
              </tr>
              <tr>
                <td className="text-dark">Venous Beading</td>
                <td><form>
                <input type="checkbox"
                 value="VenousBeading" 
                 checked={rightChecked3} 
                className="CheckBox" id="myCheckRight" 
                onChange={(e) => {handleChange("right",e.target.value,2)}
                  }/>
                    </form></td>
                <td><form>
                <input type="checkbox" 
                checked={leftChecked3} 
                className="CheckBox" 
                id="myCheckleft" 
                value="VenousBeading" 
                onChange={(e) => {handleChange("left",e.target.value,2)}}/>
               
                  </form></td>
              </tr>
              <tr style={{backgroundColor: "#e9e9e9"}}>
                <td className="text-dark">Venous Reduplication</td>
                <td><form>
                <input type="checkbox"
                  checked={rightChecked4} 
                className="CheckBox"  
                value="VenousReduplication" 
                id="myCheckRight" 
                onChange={(e) => {handleChange("right",e.target.value,3)}
                  }/>
                    </form></td>
                <td><form>
                <input type="checkbox" 
                checked={leftChecked4} 
                className="CheckBox" id="myCheckleft" 
                 value="VenousReduplication"
                onChange={(e) => {handleChange("left",e.target.value,3)}}/>
               
                  </form></td>
              </tr>
              
            </table>
            <span>
              <span  className="RigthAnswer bg-primary text-light">Right eye:</span>
            <span className="AnswerDisplay">
              {(rightChecked1 || rightChecked2 || 
                rightChecked3|| rightChecked4)?"Pre-proliferative retinopathy present":""}
              </span>
            </span>
            <span>
              <span  className="LeftAnswer bg-dark text-light">Left eye:&nbsp;&nbsp;&nbsp;</span>
            <span  className="AnswerDisplay">{(leftChecked1 || leftChecked2
               || leftChecked3||leftChecked4)?"Pre-proliferative retinopathy present":""}
            </span>
            </span>
            </div>
           
          </div>
          <br />
          <div className="container" style={{borderTop: "10px"}}>
                <div className="row">
                <div className="col-xl-4 col-md-6"></div>
                <div className="col-xl-4 col-md-6 text-center">
                <button className="btn btn btn-dark"
                  onClick={()=>{HandlePrevIn()}}
                  >Previous</button>&nbsp;
                  <button className="btn btn btn-primary"
                  onClick={()=>{HandleNextin()}}
                  >Next</button>
                </div>
                
                
                
                <div className="col-xl-4 col-md-6"></div>
              </div>
            </div>
            </div>
          </div>
        </div>
        </>
        
      );

    
                }

 
export default RetinoThree;